import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';

import withScreenIsFocused from '../components/hoc/with-screen-is-focused';
import ChevronLeftIcon from '../images/md-icons/chevron_left/materialicons/24px.svg';
import Overview from '../screens/shared/overview';
import {Pay, Complete} from '../screens/shared/checkout';
import Chat from '../screens/shared/chat';

const OverviewStack = createStackNavigator();

export default () => (
  <OverviewStack.Navigator
    initialRouteName="Chat"
    screenOptions={{
      headerBackImage: () => <ChevronLeftIcon />,
      headerShown: true,
      headerTitle: '',
      headerStyle: {
        shadowColor: 'transparent',
        borderBottomWidth: 0,
        elevation: 0,
      },
      cardStyle: {flex: 1},
    }}>
    <OverviewStack.Screen name="Chat" component={withScreenIsFocused(Chat)} />
    <OverviewStack.Screen
      name="Details"
      component={withScreenIsFocused(Overview)}
    />
    <OverviewStack.Screen
      name="Pay"
      component={withScreenIsFocused((props) => (
        <Pay {...props} canPayLater={false} />
      ))}
    />
    <OverviewStack.Screen
      name="Complete"
      component={withScreenIsFocused((props) => (
        <Complete
          {...props}
          description=""
          onComplete={() => {
            props.navigation.replace('Index', {
              order_id: props.route.params?.order_id,
            });
          }}
        />
      ))}
    />
  </OverviewStack.Navigator>
);
